import {
  CircleGeometry,
  Group,
  Mesh,
  MeshBasicMaterial,
  RepeatWrapping,
  SubtractiveBlending,
  Texture,
  TextureLoader,
} from 'three';

import { store } from 'src/app/store';
import { addToRenderLoop } from './renderLoop';
import { camera } from './scene';
import makeHashMarks from './hashCircle'

let texture: Texture;
let plane: Mesh;
const rotationSpeed = 1/10;

// create a group and attach it to the camera
export const group = new Group();
group.position.z = -camera.far;
camera.add(group);

// add hash marks to the group
const circleGroup = makeHashMarks(getRadius());
group.add(circleGroup);

// get the file url for texture
const state = store.getState();
const assetId = state.contentful.settings.fields.backgroundTextureImage['en-US'].sys.id;
const asset = state.contentful.assets[assetId];
const fileUrl = asset.fields.file['en-US'].url;

// load a resource
const loader = new TextureLoader();
loader.load(
	fileUrl,
	function (t) {
    texture = t;
		const aspectRatio = texture.image.width / texture.image.height;
		texture.wrapS = RepeatWrapping;
		texture.wrapT = RepeatWrapping;
		texture.repeat.set((1 / aspectRatio) / 2, 1 / 2);

		const material = new MeshBasicMaterial({
			map: texture,
			blending: SubtractiveBlending,
		});

		const geometry = new CircleGeometry(1, 64);
		const radius = getRadius();
		plane = new Mesh(geometry, material);
		plane.scale.set(radius, radius, 1);
		group.add(plane);
	},
	undefined, // onProgress callback currently not supported
	function ( err ) {
		console.error( 'An error happened loading the background texture.' );
	}
);

// add rotation to the render loop
addToRenderLoop(update);
function update(delta: number) {
  circleGroup.rotateZ(-delta * rotationSpeed);

  if (texture) {
    const offset = circleGroup.rotation.z / (Math.PI * 2);
    texture.offset.x = offset;
  }
}
function getRadius() {
	return 845;
	/*
	const aspectRatio = window.innerWidth / window.innerHeight;
	if (aspectRatio > 1) {
		return window.innerHeight * aspectRatio;
	} else {
		return window.innerWidth / aspectRatio;
	}
	*/
}
